// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-drawer {
  position: fixed !important;
  /* top: 0;
    right: 0;
    margin: 0;
    height: 100%; */
  /* top: 17%; */
  /* top: 45%; */
  top: 23%;
  right: 1%;
  margin: 0;
  height: 78%;
  transform: translateX(0);
  box-shadow: -4px 0px 12px rgba(0, 0, 0, 0.15);
}

.filter-drawer .modal-dialog {
  margin: 0;
  height: 100%;
  max-width: 654px !important;
  width: 654px !important;
}

.filter-drawer-content {
  height: 100%;
  /* border-radius: 0; */
}

.filter-drawer .modal-body {
  background: #ffffff;
  border: none;
  border-radius: none;
  overflow-y: auto;
}

.filter-drawer .modal-body::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

.filter-drawer .modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.filter-drawer .modal-body::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}

#filter_modal {
  width: 654px;
  height: 560px;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px !important;
  }
}

.filter-drawer .btn-link {
  text-decoration: none;
}

.filter-drawer label {
  color: #111111;
  font-size: 0.875rem;
  font-weight: 400;
}

.resetAll_btn {
  background: #ffffff;
  box-shadow: 0px 0.5px 2.5px 0px #0000004d;
  color: #0066cc;
  font-size: 0.875rem;
  font-weight: 400;
  border: none;
}

.filter-drawer .modal-footer {
  justify-content: space-between !important;
}

.filter-drawer .modal-title {
  color: #0066cc;
  font-size: 1rem;
  font-weight: 600;
}

.date_labels {
  color: #a9acb4 !important;
  font-size: 12px;
  font-weight: 400;
}

.filter-drawer .form-control:focus {
  border-color: #e4e4e4 !important;
  box-shadow: none;
}

.filter-drawer .react-datepicker__input-container input {
  color: #0066cc;
  font-size: 0.875rem;
  font-weight: 400;
}

.analytics_datepicker_container .react-datepicker-wrapper {
  width: 84% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/SystemAnalytics/FilterForm.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;;;mBAGiB;EACjB,cAAc;EACd,cAAc;EACd,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".filter-drawer {\n  position: fixed !important;\n  /* top: 0;\n    right: 0;\n    margin: 0;\n    height: 100%; */\n  /* top: 17%; */\n  /* top: 45%; */\n  top: 23%;\n  right: 1%;\n  margin: 0;\n  height: 78%;\n  transform: translateX(0);\n  box-shadow: -4px 0px 12px rgba(0, 0, 0, 0.15);\n}\n\n.filter-drawer .modal-dialog {\n  margin: 0;\n  height: 100%;\n  max-width: 654px !important;\n  width: 654px !important;\n}\n\n.filter-drawer-content {\n  height: 100%;\n  /* border-radius: 0; */\n}\n\n.filter-drawer .modal-body {\n  background: #ffffff;\n  border: none;\n  border-radius: none;\n  overflow-y: auto;\n}\n\n.filter-drawer .modal-body::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n}\n\n.filter-drawer .modal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.filter-drawer .modal-body::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n#filter_modal {\n  width: 654px;\n  height: 560px;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 700px !important;\n  }\n}\n\n.filter-drawer .btn-link {\n  text-decoration: none;\n}\n\n.filter-drawer label {\n  color: #111111;\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.resetAll_btn {\n  background: #ffffff;\n  box-shadow: 0px 0.5px 2.5px 0px #0000004d;\n  color: #0066cc;\n  font-size: 0.875rem;\n  font-weight: 400;\n  border: none;\n}\n\n.filter-drawer .modal-footer {\n  justify-content: space-between !important;\n}\n\n.filter-drawer .modal-title {\n  color: #0066cc;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.date_labels {\n  color: #a9acb4 !important;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.filter-drawer .form-control:focus {\n  border-color: #e4e4e4 !important;\n  box-shadow: none;\n}\n\n.filter-drawer .react-datepicker__input-container input {\n  color: #0066cc;\n  font-size: 0.875rem;\n  font-weight: 400;\n}\n\n.analytics_datepicker_container .react-datepicker-wrapper {\n  width: 84% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
